import styled, { css } from 'styled-components';
import { PanelContainer } from '../../panel';
import { pxToRem } from '../../../design-tokens/style-utilities';
import { GridContainerAside } from './gridAside.styled';
import { GridContainerItemContent } from './gridItem.styled';
import { getColumnStyles, getJustifyStyles } from './utilities.styled';
export const gridContainerStyles = ({ theme, $constrainedWidth, $equalHeight, $useMasonry, $columns, $hasAside, $asidePosition, $justify, $numberOfTrailingChildren, }) => css `
	display: grid;
	grid-gap: ${pxToRem(theme.spacing['300'])};
	align-content: start;
	width: 100%;
	margin: 0 auto;

	&:is(ul) {
		padding-inline-start: 0;
		list-style: none;
	}

	${$constrainedWidth &&
    css `
		max-width: ${pxToRem(theme.containerWidth.containerWidthMax)};
		padding: 0 ${pxToRem(Number(theme.spacing['200']) + Number(theme.borderWidth['2']))};
	`}

	${$justify &&
    $numberOfTrailingChildren &&
    css `
		@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) and (max-width: ${pxToRem(Number(theme.viewportBreakpoint.md) - 1)}) {
			${getJustifyStyles('md', $justify, $numberOfTrailingChildren, $columns)}
		}

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
			${getJustifyStyles('lg', $justify, $numberOfTrailingChildren, $columns)}
		}
	`}

	@media(min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		${getColumnStyles($numberOfTrailingChildren || $columns)}

		${$equalHeight &&
    css `
			${GridContainerItemContent} {
				height: 100%;

				> * {
					flex: 1;

					${PanelContainer} {
						height: 100%;
					}
				}
			}
		`}

		${$hasAside &&
    css `
			&& {
				grid-template-columns: ${$asidePosition === 'left'
        ? `calc((100% - ${pxToRem(theme.spacing['300'])})/3) calc(((100% - ${pxToRem(theme.spacing['300'])})/3) * 2)`
        : `calc(((100% - ${pxToRem(theme.spacing['300'])})/3) * 2) calc((100% - ${pxToRem(theme.spacing['300'])})/3)`};

				> [data-grid-container] {
					${getColumnStyles($columns)}
				}
			}

			${$asidePosition === 'left' &&
        css `
				${GridContainerAside} {
					grid-row: 1;
				}
			`}
		`}

		${$useMasonry &&
    css `
			grid-gap: 0 ${pxToRem(theme.spacing['300'])};

			${GridContainerItemContent} {
				padding: ${pxToRem(Number(theme.spacing['300']) / 2)};
				margin: -${pxToRem(Number(theme.spacing['300']) / 2)};
			}
		`}
	}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
		grid-gap: ${pxToRem(theme.spacing['400'])};

		${$hasAside &&
    css `
			&& {
				grid-template-columns: ${$asidePosition === 'left'
        ? `calc((100% - ${pxToRem(theme.spacing['400'])})/3) calc(((100% - ${pxToRem(theme.spacing['400'])})/3) * 2)`
        : `calc(((100% - ${pxToRem(theme.spacing['400'])})/3) * 2) calc((100% - ${pxToRem(theme.spacing['400'])})/3)`};
			}
		`}

		${$useMasonry &&
    css `
			grid-gap: 0 ${pxToRem(theme.spacing['400'])};

			${GridContainerItemContent} {
				padding: ${pxToRem(Number(theme.spacing['400']) / 2)};
				margin: -${pxToRem(Number(theme.spacing['400']) / 2)};
			}
		`}
	}
`;
export const GridContainer = styled.section `
	${gridContainerStyles}
`;
